// @ts-nocheck
import angular from 'angular';
import {Observable} from "rxjs";

export default class Media {
  constructor($log, $http, Endpoints, API_URL) {
    'ngInject';

    Object.assign(this, {
      $http,
      Endpoints,
      API_URL
    });
  }

  getFile(fileId) {
    return this.$http.get(this.Endpoints.files.one.replace(':id', fileId), {
      responseType: 'blob',
      cache: true,
      ignoreLoader: true
    });
  }

  getFileDetails(fileId) {
    return this.$http.get(`${this.API_URL}/files/${fileId}/meta`, {
      ignoreLoader: true
    });
  }

  getLabelsNew(order): Observable<any> {
    let code = order.service.code;

    if (/acne/i.test(code)) {
      code = 'ACNE';
    }

    return this.$http.get(`${this.API_URL}/diagnoses?category=${code}`, {
      cache: true,
      ignoreLoader: true
    });
  }

  getLabels(order) {
    let code = order.service.code;

    if (/acne/i.test(code)) {
      code = 'ACNE';
    }

    return this.$http.get(`${this.API_URL}/diagnoses?category=${code}`, {
      cache: true,
      ignoreLoader: true
    });
  }

  rotateImage(fileId, rotation) {
    return this.$http.put(`${this.API_URL}/files/${fileId}`, {
      rotation
    }, {
      loadingText: 'Saving rotation'
    });
  }

}

Media.$inject = ["$log", "$http", "Endpoints", "API_URL"];
// export const mediaServiceProvider = {
//   provide: Media,
//   useFactory: (i) => i.get('media'),
//   deps: ['$injector']
// }

